import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "viewHead",
  id: "image-attn-map-view"
}
const _hoisted_2 = { class: "align-top" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Image View")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "q-k attention patterns for a single image", -1)
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Show")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "visualization options:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "attention to selected token"),
    /*#__PURE__*/_createTextVNode(": heatmap for selected token; opacity denotes attention weight")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "highest attention to each token"),
    /*#__PURE__*/_createTextVNode(": top attention connection for each token in image ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "all high attention flows"),
    /*#__PURE__*/_createTextVNode(": all strong connections in image; size and opacity denote attention weight")
  ])
], -1)
const _hoisted_10 = { style: {"position":"relative"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("canvas", {
  id: "bertviz",
  class: "image-viz"
}, null, -1)
const _hoisted_12 = { id: "white-square" }
const _hoisted_13 = { class: "note" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, [
  /*#__PURE__*/_createElementVNode("b", null, "square"),
  /*#__PURE__*/_createTextVNode(" = attention to [cls] token ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, [
  /*#__PURE__*/_createElementVNode("b", null, "circle arrow"),
  /*#__PURE__*/_createTextVNode(" = attention to self ")
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _hoisted_3,
        _createVNode(_component_a_tooltip, { placement: "top" }, {
          title: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "info",
              class: "info-icon"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.attnMsg), 1),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_a_tooltip, { placement: "leftTop" }, {
          title: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "info",
              class: "info-icon"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_select, {
        value: _ctx.vizType,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vizType) = $event)),
        style: {"width":"285px"},
        options: _ctx.vizOptions
      }, null, 8, ["value", "options"])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
            [_vShow, _ctx.userTheme != 'light-theme' && _ctx.vizType == 'all_top']
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_13, _hoisted_16, 512), [
          [_vShow, _ctx.vizType != 'cur_token']
        ])
      ]),
      _: 1
    })
  ]))
}